
angular.module('app.services.search', ['ngLodash']).factory('SearchService', function($http, $log, lodash) {

  'use strict';

  var _getServlet = function() {
    return window.location.pathname.indexOf('/cs/')===0 ? '/cs' : '/ss';
  };

  var _doSearch = function(options, data) {
    var params = {};
    data = data || {};

    data.loading = true;

    var append = options.append || false;
    if (options.append) {
      delete options.append;
    }

    lodash.defaults(options, { 'start': 0, 'max': 5 });
    lodash.defaults(data, { 'items': [], 'hasMore': false, 'found': 0 });
    lodash.defaults(params, { 'pagename': 'swg/service/search', 'index': 'swgArticle' });

    lodash.assign(params, options);

    return $http.get(_getServlet() + '/Satellite', { 'params': params }).then(
        function(resp) {
          var results = resp.data.results;
          data.items = append ? lodash.union(data.items, results.items) : results.items;
          data.found = results.count;
          data.hasMore = (options.start + options.max) < data.found;
        },
        function(resp) {
          $log.error("Error in search: " + JSON.stringify(resp.data.results));
        }
      )
      .finally(function(){
        data.loading = false;
      });
  };
  
  
  
  
    var _getTweets = function(data) {
    var params = {};
    data = data || {};

    data.loading = true;

 
    lodash.defaults(data, { 'items': [] });
    lodash.defaults(params, { 'pagename': 'swg/service/twitterfeed'});


    return $http.get(_getServlet() + '/Satellite', { 'params': params }).then(
        function(resp) {
          var results = resp.data.messages;
          data.items=results;
        },
        function(resp) {
          $log.error("Error in Pulling Tweets: " + JSON.stringify(resp.builder));
        }
      )
      .finally(function(){
        data.loading = false;
      });
  };
  
  
  

  return {
    
    pullTweets: function(data) {
      

      
      return _getTweets(data);
    },
    
    findPages: function(options, data) {
      options.index = options.index || 'Global';
      return _doSearch(options, data);
    },

    findEvents: function(options, filters, data) {
      lodash.defaults(options, {
        'sort': 'startdate:false',
        'subtype': 'Event',
        'fd': 'ft'
      });
      if (filters.type) {
        options.q_State = filters.type;
      }
      return _doSearch(options, data);
    },

    findRate: function(options, data) {
      lodash.defaults(options, {
        'max': 20,
        'sort': 'name:true',
        'subtype': 'Rate'
      });
      return _doSearch(options, data);
    },

    findNewsletters: function(options, data) {
      lodash.defaults(options, {
        'sort': 'PublishedDate:true',
        'subtype': 'Newsletter'
      });
      return _doSearch(options, data);
    },

    findPDF: function(options, data) {
      lodash.defaults(options, {
        'max': 100,
        'index': 'swgMedia',
        'sort': 'name',
        'subtype': 'PDF'
      });
      return _doSearch(options, data);
    },

    findNews: function(options, filters, data) {
      lodash.defaults(options, {
        'sort': 'PublishedDate:true',
        'subtype': filters.subtype || 'InTheNews'
      });

      if (filters.q) {
        options.q = filters.q;
      } else {
        if (options.q) {
          delete options.q;
        }
      }

      if (filters.subtype) {
        options['q_' + filters.subtype + 'Category'] = filters.type;
      }

      if (filters.month === 0 && filters.year === 'All') {
        if (options.fq) {
          delete options.fq;
        }
      } else {
        options.fq = "PublishedDate:date:" + filters.year + '-' + filters.month;
      }
      return _doSearch(options, data);
    }
  };

});
